import React, { useEffect, useState } from 'react';
import Timer from 'yoda-core-components/lib/components/Timer/Timer';
import _unescape from 'lodash/unescape';
import { bool, objectOf, string } from 'prop-types';
import { connect } from 'react-redux';
import CategoryDeals from '../CategoryDeals/CategoryDeals';
import Dhtml from '../DHTML/DHTML';
import EditorialContent from '../EditorialContent/EditorialContent';
import Grid from '../../iris/wrappers/Grid/Grid';
import HotDeals from '../../iris/wrappers/HotDeals/HotDeals';
import ImageBanner from '../../iris/wrappers/ImageBanner/ImageBanner';
import IrisMapBanner from '../../iris/wrappers/ImageMapBanner/ImageMapBanner';
import ShoppableImages from '../ShoppableImages/ShoppableImages';
import VisualNav from '../../iris/wrappers/VisualNav/VisualNav';

const componentMap = {
    categoryhotdeals: EditorialContent,
    categorypromo: CategoryDeals,
    dhtml: Dhtml,
    editorial: EditorialContent,
    gridcomponent: Grid,
    hero: EditorialContent,
    herovariant: EditorialContent,
    hotdeals: HotDeals,
    imagebanner: ImageBanner,
    imagehotspots: IrisMapBanner,
    nucleus: EditorialContent,
    shoppableimages: ShoppableImages,
    story: EditorialContent,
    timer: Timer,
    visualnav: VisualNav,
};

export const getComponent = (
    { componentType, id: key, content: receivedProps } = {},
    parentProps = {}
) => {
    const isComponentInMap = Object.prototype.hasOwnProperty.call(componentMap, componentType);
    const DynamicComponent = componentMap[componentType];
    const combinedProps = { ...parentProps, ...receivedProps, componentType, key };

    return isComponentInMap ? <DynamicComponent {...combinedProps} /> : null;
};

const PersonalizedContent = (props) => {
    const {
        deviceType: { isMobile, isTablet },
        mbox,
        yodaCacheControl,
    } = props;

    const [adobeOffers, setAdobeOffers] = useState({});
    const [offerExpirationDate, setOfferExpirationDate] = useState(0);
    const [adobeAudience, setAdobeAudience] = useState('');

    useEffect(() => {
        /* istanbul ignore next */
        window &&
            window.adobe &&
            window.adobe.target &&
            window.adobe.target
                .getOffers({
                    request: {
                        execute: {
                            mboxes: [
                                {
                                    index: 0,
                                    name: mbox,
                                },
                            ],
                        },
                        experienceCloud: {
                            analytics: {
                                supplementalDataId:
                                    window &&
                                    window.visitor &&
                                    window.visitor._supplementalDataIDCurrent,
                            },
                        },
                    },
                })
                .then((offer) => {
                    const { execute: { mboxes: [mboxItem = {}] = [] } = {} } = offer;
                    const { options: [optionContent = {}] = [] } = mboxItem;
                    const {
                        content = '',
                        responseTokens: { 'experience.name': experienceName = '' } = {},
                    } = optionContent;
                    const irisDataRegex = /(?=<div data-pcId="personalizedIrisResponse">\s*).*?(?=\s*<\/div>)/gim;
                    const adobeDataAsMarkup = content && content.match(irisDataRegex);
                    // Unescaping data and replacing characters with their equivalent value
                    const adobeDataDecoded = adobeDataAsMarkup
                        ? _unescape(
                              adobeDataAsMarkup[0]
                          ).replaceAll(
                              /(&#x27;)|(<div data-pcid="personalizedIrisResponse">)/g,
                              ($0) => ($0 === '&#x27;' ? `'` : '')
                          )
                        : '';

                    experienceName && setAdobeAudience(experienceName.replaceAll(' ', ''));
                    adobeDataDecoded.length && setAdobeOffers(JSON.parse(adobeDataDecoded));
                });
    }, []);

    /* istanbul ignore next */
    useEffect(() => {
        adobeOffers.CacheControl &&
            adobeOffers.CacheControl[0] &&
            setOfferExpirationDate(new Date(adobeOffers.CacheControl[0]).getTime());
    }, [adobeOffers]);

    let channel = 'desktop';
    if (isMobile) channel = 'mobile';
    if (isTablet) channel = 'tablet';

    /* istanbul ignore next */
    const adobeOfferComponents = (adobeOffers[channel] && adobeOffers[channel].components) || [];
    const cacheExpiration = yodaCacheControl.length ? new Date(yodaCacheControl).getTime() : 0;
    const isOfferValid = offerExpirationDate >= cacheExpiration;

    /* istanbul ignore next */
    return isOfferValid && adobeOfferComponents.length ? (
        <>
            {adobeOfferComponents.map((component) =>
                getComponent(component, { ...props, adobeAudience })
            )}
        </>
    ) : null;
};

PersonalizedContent.propTypes = {
    deviceType: objectOf(bool).isRequired,
    mbox: string.isRequired,
    yodaCacheControl: string.isRequired,
};

const mapStateToProps = (store) => ({
    deviceType: store.context && store.context.deviceType,
    yodaCacheControl: (store.irisData && store.irisData.yodaCacheControl) || '',
});

export default connect(mapStateToProps)(PersonalizedContent);
